export default "__VITE_ASSET__f333e427__"